import { api } from "@/lib/api";
import {
  CreateWorker,
  mapCreateWorkerToDto,
  mapWorkerFromDto,
  Worker,
  WorkerDtoSchema,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getWorkersQueryOptions } from "./get.hooks";

export function useCreateWorker(opts?: {
  onSuccess?: (worker: Worker) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (worker: CreateWorker) => {
      const dto = mapCreateWorkerToDto(worker);
      const result = await api.post("/api/workers", dto, WorkerDtoSchema);
      return mapWorkerFromDto(result);
    },
    onSuccess: (worker) => {
      queryClient.setQueryData(getWorkersQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        worker,
      ]);
      toast({
        title: "toast.workerCreated",
        variant: "success",
      });
      opts?.onSuccess?.(worker);
    },
    onError: () => {
      toast({
        title: "toast.createWorkerError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
